import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import "spot-component-library/lib/resources/icons/style.css";
import "./i18n";
import ContentDemo from "./main/ContentDemo";
import Footer from "./main/components/footer/Footer";
import Header from "./main/components/header/Header";
import CookiePolicy from "./main/pages/cookiePolicy/CookiePolicy";
import LegalNotice from "./main/pages/legalNotice/LegalNotice";
import PrivacyPolicy from "./main/pages/privacyPolicy/PrivacyPolicy";
import Instruction from "./main/pages/content/instructions/InstructionsPage";
import { StartPage } from "./main/pages/startPage/StartPage";
import { DsgvoPage } from "./main/pages/content/dsgvo/DsgvoPage";
import { DownloadPage } from "./main/pages/content/download/DownloadPage";
import { GeneralQuestionPage } from "./main/pages/content/generalQuestions/generalQuestionPage";
import EaaPrivacyPage from "./main/pages/eaaPrivacyPage/EaaPrivacyPage";
import { EasyLanguagePage } from "./main/pages/content/easyLanguage/EasyLanguagePage";

const fallback = <></>;

const eosContentDemo = document.getElementById("eos-content-demo");
if (eosContentDemo) {
    ReactDOM.render(
        <React.StrictMode>
            <Suspense fallback={fallback}>
                <ContentDemo />
            </Suspense>
        </React.StrictMode>,
        eosContentDemo
    );
}

const eosCookiePolicy = document.getElementById("eos-cookie-policy");
if (eosCookiePolicy) {
    ReactDOM.render(
        <React.StrictMode>
            <Suspense fallback={fallback}>
                <CookiePolicy />
            </Suspense>
        </React.StrictMode>,
        eosCookiePolicy
    );
}

const eosPrivacyPolicy = document.getElementById("eos-privacy-policy");
if (eosPrivacyPolicy) {
    ReactDOM.render(
        <React.StrictMode>
            <Suspense fallback={fallback}>
                <PrivacyPolicy />
            </Suspense>
        </React.StrictMode>,
        eosPrivacyPolicy
    );
}

const eaaPrivacyPage = document.getElementById("eaa-privacy-page");
if (eaaPrivacyPage) {
    ReactDOM.render(
        <React.StrictMode>
            <Suspense fallback={fallback}>
                <EaaPrivacyPage />
            </Suspense>
        </React.StrictMode>,
        eaaPrivacyPage
    );
}

const easyLanguagePage = document.getElementById("easy-language-page");
if (easyLanguagePage) {
    ReactDOM.render(
        <React.StrictMode>
            <Suspense fallback={fallback}>
                <EasyLanguagePage />
            </Suspense>
        </React.StrictMode>,
        easyLanguagePage
    );
}

const eosLegalNotice = document.getElementById("eos-legal-notice");
if (eosLegalNotice) {
    ReactDOM.render(
        <React.StrictMode>
            <Suspense fallback={fallback}>
                <LegalNotice />
            </Suspense>
        </React.StrictMode>,
        eosLegalNotice
    );
}

const instructionPage = document.getElementById("instruction-page");
if (instructionPage) {
    ReactDOM.render(
        <React.StrictMode>
            <Suspense fallback={fallback}>
                <Instruction />
            </Suspense>
        </React.StrictMode>,
        instructionPage
    );
}

const generalQuestion = document.getElementById("generalQuestions-page");
if (generalQuestion) {
    ReactDOM.render(
        <React.StrictMode>
            <Suspense fallback={fallback}>
                <GeneralQuestionPage />
            </Suspense>
        </React.StrictMode>,
        generalQuestion
    );
}

const startPage = document.getElementById("start-page");
if (startPage) {
    ReactDOM.render(
        <React.StrictMode>
            <Suspense fallback={fallback}>
                <StartPage />
            </Suspense>
        </React.StrictMode>,
        startPage
    );
}

const dsgvoPage = document.getElementById("dsgvo-page");
if (dsgvoPage) {
    ReactDOM.render(
        <React.StrictMode>
            <Suspense fallback={fallback}>
                <DsgvoPage />
            </Suspense>
        </React.StrictMode>,
        dsgvoPage
    );
}

const downloadPage = document.getElementById("download-page");
if (downloadPage)
    ReactDOM.render(
        <React.StrictMode>
            <Suspense fallback={fallback}>
                <DownloadPage />
            </Suspense>
        </React.StrictMode>,
        downloadPage
    );

export const render = (containerId: string, data: any) => {
    renderWithCss(containerId, data);
};

export const unMount = (containerId: string) => {
    const container = document.getElementById(containerId);
    if (!container) return;
    ReactDOM.unmountComponentAtNode(container);
};

const renderWithCss = (containerId: string, data: any) => {
    // @ts-ignore inject from webpack build
    const cssFileVersion = __BUILD_VERSION_HASH__;

    // create new link tag
    const link = document.createElement("link");
    link.href = "/services/content/main.css?v=" + cssFileVersion;
    link.rel = "stylesheet";
    link.type = "text/css";
    // @ts-ignore css loading finished
    link.onload = () => {
        const container = document.getElementById(containerId);
        if (!container) return;
        if (containerId === "eos-header") {
            ReactDOM.render(
                <Suspense fallback={fallback}>
                    <Header {...data} />
                </Suspense>,
                container
            );
        } else if (containerId === "eos-footer") {
            ReactDOM.render(
                <Suspense fallback={fallback}>
                    <Footer />
                </Suspense>,
                container
            );
        }
    };

    // Loading failed
    link.onerror = function () {
        console.error("Can't load css styles for content! ");
    };

    // append link element to html
    document.body.appendChild(link);
};
